import { render, staticRenderFns } from "./job-employment-position-helper-components-3-resource-list.vue?vue&type=template&id=0d5ac11e&"
import script from "./job-employment-position-helper-components-3-resource-list.vue?vue&type=script&lang=ts&"
export * from "./job-employment-position-helper-components-3-resource-list.vue?vue&type=script&lang=ts&"
import style0 from "./job-employment-position-helper-components-3-resource-list.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports